import { notifications } from "@mantine/notifications";
import { IconCheck, IconCircleX } from "@tabler/icons-react";
import type { ReactNode } from "react";

export const toast = {
    error: (message: ReactNode) =>
        notifications.show({
            title: "Error",
            message,
            color: "red",
            icon: <IconCircleX />,
        }),
    success: (message: ReactNode) =>
        notifications.show({
            title: "Success",
            message,
            color: "green",
            icon: <IconCheck />,
        }),
};
